<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    created() {

    },
};
</script>

<style lang="less">
@import "styles/style.less";
@import "styles/base.less";
@import "styles/global.less";

.el-menu-item {
    &:hover {
        // background-color: rgba(0, 0, 0, 0.2) !important;
        background-color: red !important;
    }
}

/deep/ .el-menu-item {
    &:hover {
        // background-color: rgba(0, 0, 0, 0.2) !important;
        background-color: red !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue